/// Yalnız ilk boyamada gereken tek dosya: Inter 400 (gövde metni; latin + Türkçe glifleri
/// tek dosyada). 600/700 preload edilmez: font-display: swap ile kritik yol dışında gelir.
export const PRELOADED_FONTS: readonly string[] = ['/assets/fonts/inter/inter-tr-400.woff2'];

export function ensureFontPreloads(doc: Document): void {
  for (const href of PRELOADED_FONTS) {
    if (doc.head.querySelector(`link[rel="preload"][href="${href}"]`)) continue;
    const link = doc.createElement('link');
    link.setAttribute('rel', 'preload');
    link.setAttribute('as', 'font');
    link.setAttribute('type', 'font/woff2');
    link.setAttribute('href', href);
    link.setAttribute('crossorigin', '');
    doc.head.appendChild(link);
  }
}
